import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'sn-toggle',
	template: require('./toggle.component.html'),
	styles: [require('./toggle.component.scss')]
})
export class ToggleComponent {
	@Input() id: string;
	@Input() disabled = false;
	@Output() toggleChanged: EventEmitter<boolean> = new EventEmitter<boolean>();
	enabled: boolean;
	showAnimation = false;

	constructor() {}

	@Input('enabled')
	set _enabled(value) {
		this.enabled = value;
		// this setTimeout enables animation after setting default value
		setTimeout((): void => {
			this.showAnimation = true;
		}, 0);
	}

	changeToggle(value): void {
		if (value !== this.enabled) {
			this.toggleChanged.emit(value);
		}
	}

	emitToggleChange(e): void {
		e.preventDefault();
		this.toggleChanged.emit(!this.enabled);
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/common/toggle/toggle.component.ts